const actions = {
  SET_STATE: 'photobooth/SET_STATE',
}

export default actions
